<div class="vstack gap-1">
    <div class="hstack justify-content-between align-items-center">
        <div class="small text-muted">Guest choices entered</div>
        <div
            class="small fw-semibold"
            data-testid="menu-choices-progress-completed"
        >
            {{ completedCovers }} / {{ totalCovers }} Entered
        </div>
    </div>
    <div class="progress" role="progressbar" aria-label="Choices progress" [attr.aria-valuenow]="completedCovers" [attr.aria-valuemin]="0" [attr.aria-valuemax]="totalCovers" style="height: 6px;">
        <div class="progress-bar" [style.width.%]="progressPercent"></div>
    </div>
</div>
